/**
 * Colour tokens for places Tailwind classes cannot reach (canvas, SVG strokes, inline styles).
 * Keep in sync with tailwind.config.js.
 */
export const IDLE = '#6B7480';
export const POSITIVE = '#8FD99A';
export const NEGATIVE = '#F29B8F';
